/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import StyleguideView from "@/src/styleguide/components/StyleguideView/StyleguideView";
import Container from "@/src/components/Container/Container";

export default function ContainerStyleguide() {
  return (
    <>
      <StyleguideView title={"Containers"} fullWidth>
        <Container variant={"full"} sx={(theme) => ({ backgroundColor: theme.palette.background.light })}>
          <strong>full</strong> max-width: none
        </Container>
        <Container variant={"xl"} sx={(theme) => ({ backgroundColor: theme.palette.background.light, marginTop: "2rem" })}>
          <strong>xl</strong> max-width: 1440px
        </Container>
        <Container variant={"lg"} sx={(theme) => ({ backgroundColor: theme.palette.background.light, marginTop: "2rem" })}>
          <strong>lg</strong> max-width: 1296px
        </Container>
        <Container variant={"md"} sx={(theme) => ({ backgroundColor: theme.palette.background.light, marginTop: "2rem" })}>
          <strong>md</strong> max-width: 1104px
        </Container>
        <Container variant={"sm"} sx={(theme) => ({ backgroundColor: theme.palette.background.light, marginTop: "2rem" })}>
          <strong>sm</strong> max-width: 880px
        </Container>
        <Container variant={"xs"} sx={(theme) => ({ backgroundColor: theme.palette.background.light, marginTop: "2rem" })}>
          <strong>xs</strong> max-width: 720px
        </Container>
      </StyleguideView>
      <StyleguideView title={"Containers"} subtitle={"No block padding"} fullWidth>
        <Container variant={"full"} showVerticalPadding={false} sx={(theme) => ({ backgroundColor: theme.palette.background.light })}>
          <strong>full</strong> max-width: none
        </Container>
        <Container variant={"xl"} showVerticalPadding={false} sx={(theme) => ({ backgroundColor: theme.palette.background.light, marginTop: "2rem" })}>
          <strong>xl</strong> max-width: 1440px
        </Container>
        <Container variant={"lg"} showVerticalPadding={false} sx={(theme) => ({ backgroundColor: theme.palette.background.light, marginTop: "2rem" })}>
          <strong>lg</strong> max-width: 1296px
        </Container>
        <Container variant={"md"} showVerticalPadding={false} sx={(theme) => ({ backgroundColor: theme.palette.background.light, marginTop: "2rem" })}>
          <strong>md</strong> max-width: 1104px
        </Container>
        <Container variant={"sm"} showVerticalPadding={false} sx={(theme) => ({ backgroundColor: theme.palette.background.light, marginTop: "2rem" })}>
          <strong>sm</strong> max-width: 880px
        </Container>
        <Container variant={"xs"} showVerticalPadding={false} sx={(theme) => ({ backgroundColor: theme.palette.background.light, marginTop: "2rem" })}>
          <strong>xs</strong> max-width: 720px
        </Container>
      </StyleguideView>
    </>
  );
}
